import { http } from '../index';
import { formDataModifier } from '../modifiers';
import { downloadFileFromBytes, getFileNameFromContentDispositionString } from '../helpers';

export const getTrainingPartFilesList = (trainingPartId, params) =>
  http
    .get(`/training-parts/${trainingPartId}/files/list`, { params })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

const fetchTrainingPartFileBlob = (trainingPartId, fileId) =>
  http
    .get(`/training-parts/${trainingPartId}/files/${fileId}/download`, {
      responseType: 'blob',
    })
    .then(res => res)
    .catch(error => Promise.reject(error.response?.data || error));

export const openTrainingPartFile = (trainingPartId, fileId, fallbackFileName = '') =>
  fetchTrainingPartFileBlob(trainingPartId, fileId).then(res => {
    const fileName = getFileNameFromContentDispositionString(res) || fallbackFileName || 'file';
    const blob = res.data instanceof Blob ? res.data : new Blob([res.data]);
    const url = window.URL.createObjectURL(blob);
    const openedWindow = window.open(url, '_blank', 'noopener,noreferrer');

    if (!openedWindow) {
      downloadFileFromBytes(res.data, fileName, '', true);
      window.URL.revokeObjectURL(url);
      return res;
    }

    window.setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    return res;
  });

export const downloadTrainingPartFile = (trainingPartId, fileId, fallbackFileName = '') =>
  fetchTrainingPartFileBlob(trainingPartId, fileId).then(res => {
    const fileName = getFileNameFromContentDispositionString(res) || fallbackFileName || 'file';
    downloadFileFromBytes(res.data, fileName, '', true);
    return res;
  });

export const uploadTrainingPartFile = (trainingPartId, file) =>
  http
    .post(`/training-parts/${trainingPartId}/files`, formDataModifier({ file }), {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const deleteTrainingPartFile = (trainingPartId, fileId) =>
  http
    .delete(`/training-parts/${trainingPartId}/files/${fileId}`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const updateTrainingPartFileVisibility = (trainingPartId, fileId, data) =>
  http
    .post(`/training-parts/${trainingPartId}/files/${fileId}/visibility`, data)
    .then(res => res.data)
    .catch(error => error.response?.data || error);
